<template>
  <v-app>
    <AdminPanel />
    <TopNav />

    <v-main class="main">
      <v-container
        class="d-flex mt-2 justify-space-between pb-0 mb-0 top-container"
      >
        <Breadcrums />
        <div></div>
        <SocialShare />
      </v-container>
      <v-row class="" v-if="loading">
        <v-col cols="12">
          <div class="d-flex justify-space-around align-center flex-wrap ">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>
      </v-row>
      <transition :name="transitionName">
        <router-view class="child-view"></router-view>
      </transition>
    </v-main>
    <Footer />
    <v-snackbar
      class="mt-20"
      v-model="snackRefreshUI"
      top
      centered
      timeout="-1"
      style="z-index: 99999999"
    >
      <v-icon color="primary " class="mr-2">mdi-party-popper</v-icon> Det finns
      en ny version av Livet i havet.
      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="refreshing"
          text
          color="primary"
          v-bind="attrs"
          @click.stop="refreshApp"
        >
          Uppdatera
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
      class="mt-20"
      v-model="isDownloading"
      top
      centered
      timeout="-1"
      style="z-index: 99999999"
    >
      <v-icon color="primary " class="mr-2">mdi-cloud-download-outline</v-icon
      >Laddar ner data..
    </v-snackbar>

    <NavigationDrawer />
    <FindMyLocationSnackbar />
    <BottomNav />
    <!-- <CacheCheck /> -->
  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue'

import NavigationDrawer from '@/components/NavigationDrawer.vue'
import FindMyLocationSnackbar from '@/components/FindMyLocationSnackbar.vue'
import Breadcrums from '@/components/Breadcrums.vue'
import AdminPanel from '@/components/AdminPanel.vue'
import SocialShare from '@/components/SocialShare.vue'
import BottomNav from '@/components/BottomNav.vue'
import GeoStuff from '@/mixins/GeoStuff.js'
// import CacheCheck from '@/components/CacheCheck.vue'
import TopNav from '@/components/TopNav.vue'

export default {
  name: 'App',
  mixins: [GeoStuff],
  components: {
    Footer,
    NavigationDrawer,
    FindMyLocationSnackbar,
    Breadcrums,
    AdminPanel,
    SocialShare,
    BottomNav,
    TopNav
    // CacheCheck
  },
  beforeRouteLeave(to, from, next) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    next()
  },
  updated() {
    document.title = 'Livet i havet'
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      snackRefreshUI: false,
      isDownloading: false,
      group: null,
      transitionName: 'slide-left',
      appBarTextOpacity: 1
    }
  },
  computed: {
    loading() {
      return !this.$store.state.ready
    }
  },
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    // Refresh all open app tabs when a new service worker is installed.
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
      navigator.serviceWorker.addEventListener('message', e => {
        if (e.data === 'beforePrecache') {
          console.log('beforePrecache')
          // this.isDownloading = true
        }
        if (e.data === 'afterPrecache') {
          console.log('afterPrecache')
          this.isDownloading = false
        }
      })
    }
  },
  methods: {
    onScroll(evt) {
      const offset = evt.target.defaultView.pageYOffset
      const limit = 90
      this.appBarTextOpacity = 1 - offset / limit
    },
    goHome() {
      this.$router.push({ name: 'Home' })
    },
    showRefreshUI(e) {
      this.registration = e.detail
      this.snackRefreshUI = true
    },
    refreshApp() {
      // this.snackRefreshUI = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    }
  }
}
</script>
<style scoped>
.top-container {
  position: relative;
}
.bar {
  background: rgb(33, 162, 97);
  background: linear-gradient(
      0deg,
      rgba(33, 162, 97, 1) 0%,
      rgba(33, 162, 97, 0) 78%
    ),
    url(https://havetstore.blob.core.windows.net/bilder/livet-pwa/bakgrund.png)
      repeat;
}

.h5,
.subtitle-1 {
  color: white;
}
.menu {
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  /* align-items: center; */
}
.hamburger {
  display: flex;
  justify-content: flex-end;
  color: white;
  align-items: center;
}
.menu-item,
.menu-container {
  align-self: center;
}
.logo {
  cursor: pointer;
}
.menu-item span:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hamburger,
.globe {
  float: right;
}

.fold-menu {
  background: cornflowerblue;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.child-view {
  position: relative;
  transition: all 0.25s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(60px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-60px, 0);
}
.top {
  z-index: 9999999;
}
geo-text {
  text-decoration: none;
}
geo-text:hover {
  text-decoration: underline;
}
.inside-header-container {
  transform: translateY(60px);
}
.inside-header {
  color: #fff;
  display: flex;
  width: 100%;
  justify-content: center;
  text-align: center;
  font-size: 2.05rem !important;
  font-weight: 400;
  line-height: 2.5rem;
  letter-spacing: 0.0073529412em !important;
  font-family: 'Roboto', sans-serif !important;
}
.inside-header-small {
  font-size: 1.4rem !important;
}
</style>
<style>
.youtube-iframe {
  width: 100%;
  height: 450px;
}
.v-app-bar {
  z-index: 500;
}
.v-carousel__controls {
  padding-bottom: 20px;
}
.livet-carousel-showing-video .v-carousel__controls {
  display: none;
}
</style>
